import { createAction, props } from "@ngrx/store";
import { SoldSeats } from "../interfaces/State/Seat/sold-seats";
import { SectorData } from "../interfaces/State/Sector/sector-data";

export const setSectorData = createAction('setSectorData', props<{sectorData: SectorData}>())